document.addEventListener('DOMContentLoaded', function() {
  const slideshows = document.querySelectorAll('.t4s-slideshow-wrapper');
  
  slideshows.forEach(function(wrapper) {
    const slideshow = wrapper.querySelector('.t4s-slideshow');
    const slides = wrapper.querySelectorAll('.t4s-slide');
    const prevButton = wrapper.querySelector('.t4s-slide-prev');
    const nextButton = wrapper.querySelector('.t4s-slide-next');
    const dots = wrapper.querySelectorAll('.t4s-dot');
    
    let currentSlide = 0;
    let autoplayInterval;
    const autoplay = wrapper.dataset.autoplay === 'true';
    const speed = parseInt(wrapper.dataset.speed) * 1000;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!slideshow || slides.length === 0) {
      return;
    }
    
    function goToSlide(index) {
      slideshow.style.transform = `translateX(-${index * 100}%)`;
      currentSlide = index;
      
      // Update dots
      dots.forEach(dot => dot.classList.remove('active'));
      if (dots[currentSlide]) {
        dots[currentSlide].classList.add('active');
      }
    }
    
    function nextSlide() {
      goToSlide(currentSlide === slides.length - 1 ? 0 : currentSlide + 1);
    }
    
    function prevSlide() {
      goToSlide(currentSlide === 0 ? slides.length - 1 : currentSlide - 1);
    }
    
    // Event listeners
    if (slides.length > 1) {
      if (prevButton) {
        prevButton.addEventListener('click', prevSlide);
      }
      if (nextButton) {
        nextButton.addEventListener('click', nextSlide);
      }
    }
    
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => goToSlide(index));
    });
    
    // Autoplay
    if (autoplay && slides.length > 1 && !prefersReducedMotion) {
      function startAutoplay() {
        clearInterval(autoplayInterval);
        autoplayInterval = setInterval(nextSlide, speed);
      }
      
      function stopAutoplay() {
        clearInterval(autoplayInterval);
      }
      
      wrapper.addEventListener('mouseenter', stopAutoplay);
      wrapper.addEventListener('mouseleave', startAutoplay);
      document.addEventListener('visibilitychange', function() {
        if (document.hidden) {
          stopAutoplay();
        } else {
          startAutoplay();
        }
      });
      
      startAutoplay();
    }
    
    // Touch events
    let touchStartX = 0;
    let touchEndX = 0;
    
    wrapper.addEventListener('touchstart', e => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    
    wrapper.addEventListener('touchend', e => {
      touchEndX = e.changedTouches[0].screenX;
      if (touchStartX - touchEndX > 50) {
        nextSlide();
      } else if (touchEndX - touchStartX > 50) {
        prevSlide();
      }
    }, { passive: true });
  });
}); 
